import { TableBody } from '@mui/material'
import { FieldArray } from 'formik'
import { ReactElement } from 'react'
import Row from './Row'

const Table = (): ReactElement => {
  return (
    <TableBody>
      <FieldArray
        name="items"
        render={(arrayHelpers) => {
          return arrayHelpers?.form?.values?.items?.map((item, index) => (
            <Row
              key={`manually_add_part_row_${index}`}
              item={{ ...item, id: index }}
              remove={arrayHelpers.remove}
            />
          ))
        }}
      />
    </TableBody>
  )
}

export default Table
